import { PW_WARNING_BAR_LOADED } from 'utilities/consts/variable-types.js';
import { WarningSeverity } from 'utilities/weather-warnings/warning-severity.js';
import { PanelLargeHeaderWarnings } from './header-inline-warning.js';
import { PanelHeaderConfig } from './utils/format-for-location-warning.js';

interface IProps {
  warnings: PanelHeaderConfig[];
}

const groupWarnLevels = (levels: `${WarningSeverity}`[]) =>
  Object.values(WarningSeverity).reduce<Record<WarningSeverity, number>>(
    (acc, level) => ({ ...acc, [level]: levels.filter((l) => l === level).length }),
    {} as Record<WarningSeverity, number>,
  );

const convertMessagesToMobileString = (allWarnings: PanelHeaderConfig[]) => {
  /** merge any objects with same name and warn level */
  const { red, orange, yellow, blue } = groupWarnLevels(allWarnings.map((w) => w.warnLevel));
  const warnings = red + orange;
  const watch = yellow;

  if (warnings || watch) {
    const warningsMessage = warnings > 0 ? `${warnings} Warning${warnings > 1 ? 's' : ''}` : '';
    const watchMesssage = watch > 0 ? `${watch} Watch${watch > 1 ? 'es' : ''}` : '';
    return [warningsMessage, watchMesssage].filter(Boolean).join(', ');
  }
  /** No red, orange or yellow warnings so check blue */
  if (blue) {
    const blueWarnings = allWarnings.filter((w) => w.warnLevel === WarningSeverity.Blue);
    if (blueWarnings.length) {
      const hasWeatherSeverity = blueWarnings.findIndex((b) => b.label === 'Severe Weather Outlook');
      if (hasWeatherSeverity >= 0) {
        return 'Severe Weather Outlook';
      }
      return blueWarnings[0].label;
    }
  }

  return '';
};

export const WarningsPanelHeaderLoaded = ({ warnings }: IProps) => {
  /** merge any objects with same name and warn level */
  // const groupedWarnings = groupWarnLevels(warnings.map((w) => w.warnLevel));
  const message = convertMessagesToMobileString(warnings);

  return (
    <>
      {/* {text for mobile} */}
      {message && (
        <li className="WeatherWarning-bar-warning-item u-lg-hidden" data-testid={PW_WARNING_BAR_LOADED}>
          {<span>{message}</span>}
        </li>
      )}
      {/* {text for tablet} */}
      {warnings.map((props, i) => (
        <PanelLargeHeaderWarnings
          key={i}
          warnLevel={props.warnLevel}
          icon={props.icon}
          label={props.label}
          url={props.url}
        />
      ))}
    </>
  );
};
